module.exports = __webpack_public_path__ + "static/img/banner-1.d5f0bc27.png";